module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink treeview",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', {
    staticClass: "treeview-link"
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page treeview-title"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), (this.$store.getters.modules.includes(',11.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('11.01')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('11.01')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/eventReport"
    }
  }, [_c('a', [_vm._v("Report")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',21.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('21.1') ||
    this.$store.getters.modules.includes('21.2')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('21.1')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/adminOrganization"
    }
  }, [_c('a', [_vm._v("Organization")])]) : _vm._e()], 1), _vm._v("allUser\n            "), _c('li', [(this.$store.getters.modules.includes('21.2')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/adminUser"
    }
  }, [_c('a', [_vm._v("Admin User")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('21.2')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/allUser"
    }
  }, [_c('a', [_vm._v("All User List")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('21.3')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/adminInquiry"
    }
  }, [_c('a', [_vm._v("Admin Inquiry")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',1.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(
    this.$store.getters.modules.includes('1.01') ||
    this.$store.getters.modules.includes('1.02') ||
    this.$store.getters.modules.includes('1.03') ||
    this.$store.getters.modules.includes('1.04') ||
    this.$store.getters.modules.includes('1.05') ||
    this.$store.getters.modules.includes('1.06') ||
    this.$store.getters.modules.includes('1.07') ||
    this.$store.getters.modules.includes('1.08')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('1.01')) ? _c('router-link', {
    attrs: {
      "to": "/accountGroup"
    }
  }, [_c('a', [_vm._v("Account Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.02')) ? _c('router-link', {
    attrs: {
      "to": "/accountSubGroup"
    }
  }, [_c('a', [_vm._v("Account Sub Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.02')) ? _c('router-link', {
    attrs: {
      "to": "/accountSubGroupChild"
    }
  }, [_c('a', [_vm._v("Account Child Sub Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.03')) ? _c('router-link', {
    attrs: {
      "to": "/accountmaster"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("General Account Master")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.04')) ? _c('router-link', {
    attrs: {
      "to": "/supplieraccount"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Supplier Account")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.05')) ? _c('router-link', {
    attrs: {
      "to": "/customeraccount"
    }
  }, [_c('a', [_vm._v("Customer Account")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.23')) ? _c('router-link', {
    attrs: {
      "to": "/CustomerFollowUpList"
    }
  }, [_c('a', [_vm._v("Customer FollowUp Accounts")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.06')) ? _c('router-link', {
    attrs: {
      "to": "/bankDetail"
    }
  }, [_c('a', [_vm._v("Bank Account")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.07')) ? _c('router-link', {
    attrs: {
      "to": "/incomeaccount"
    }
  }, [_c('a', [_vm._v("Income Account")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.08')) ? _c('router-link', {
    attrs: {
      "to": "/expensesaccount"
    }
  }, [_c('a', [_vm._v("Expenses Account")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('1.09') ||
    this.$store.getters.modules.includes('1.11') ||
    this.$store.getters.modules.includes('1.12') ||
    this.$store.getters.modules.includes('1.13')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(6), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('1.09')) ? _c('router-link', {
    attrs: {
      "to": "/itemgroup"
    }
  }, [_c('a', [_vm._v("Item Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.11')) ? _c('router-link', {
    attrs: {
      "to": "/itemsubgroup"
    }
  }, [_c('a', [_vm._v("Item Sub Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.13')) ? _c('router-link', {
    attrs: {
      "to": "/measurementunit"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Measurement Unit")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.18')) ? _c('router-link', {
    attrs: {
      "to": "/unitConversion"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unit Conversion")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.12')) ? _c('router-link', {
    attrs: {
      "to": "/itemmaster"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("General Item Master")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('1.14') ||
    this.$store.getters.modules.includes('1.15')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('1.14')) ? _c('router-link', {
    attrs: {
      "to": "/warehousegroup"
    }
  }, [_c('a', [_vm._v("Store Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.15')) ? _c('router-link', {
    attrs: {
      "to": "/warehouse"
    }
  }, [_c('a', [_vm._v("Store Master")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('1.16') ||
    this.$store.getters.modules.includes('1.17')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(8), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('1.16')) ? _c('router-link', {
    attrs: {
      "to": "/billsundrypurchase"
    }
  }, [_c('a', [_vm._v(" Bill Sundry on Purchase")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.17')) ? _c('router-link', {
    attrs: {
      "to": "/billsundrysales"
    }
  }, [_c('a', [_vm._v("Bill Sundry on Sales")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.24')) ? _c('router-link', {
    attrs: {
      "to": "/transportationDetails"
    }
  }, [_c('a', [_vm._v("Transportation Details")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('1.19') ||
    this.$store.getters.modules.includes('1.21') || this.$store.getters.modules.includes('1.22')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('1.19')) ? _c('router-link', {
    attrs: {
      "to": "/costCenterGroup"
    }
  }, [_c('a', [_vm._v(" Cost Center Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.21')) ? _c('router-link', {
    attrs: {
      "to": "/costCenterSubGroup"
    }
  }, [_c('a', [_vm._v("Cost Center Subgroup")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('1.22')) ? _c('router-link', {
    attrs: {
      "to": "/costCenterSetup"
    }
  }, [_c('a', [_vm._v(" Cost Center Setup")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',2.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(
    this.$store.getters.modules.includes('2.01') ||
    this.$store.getters.modules.includes('2.02') ||
    this.$store.getters.modules.includes('2.03') ||
    this.$store.getters.modules.includes('2.04') ||
    this.$store.getters.modules.includes('2.05')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(11), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('2.01')) ? _c('router-link', {
    attrs: {
      "to": "/journal"
    }
  }, [_c('a', [_vm._v("Journal")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.02')) ? _c('router-link', {
    attrs: {
      "to": "/payment"
    }
  }, [_c('a', [_vm._v("Payment")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.03')) ? _c('router-link', {
    attrs: {
      "to": "/receipt"
    }
  }, [_c('a', [_vm._v("Receipt")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.04')) ? _c('router-link', {
    attrs: {
      "to": "/debitnote"
    }
  }, [_c('a', [_vm._v("Debit Note (w/o items)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.05')) ? _c('router-link', {
    attrs: {
      "to": "/creditnote"
    }
  }, [_c('a', [_vm._v("Credit Note (w/o items)")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('2.06') ||
    this.$store.getters.modules.includes('2.07') ||
    this.$store.getters.modules.includes('2.08') ||
    this.$store.getters.modules.includes('2.09') ||
    this.$store.getters.modules.includes('2.26') ||
    this.$store.getters.modules.includes('2.21')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(12), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('2.06')) ? _c('router-link', {
    attrs: {
      "to": "/salesorder"
    }
  }, [_c('a', [_vm._v("Sales Order")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.07')) ? _c('router-link', {
    attrs: {
      "to": "/saleschallan"
    }
  }, [_c('a', [_vm._v("Sales Challan")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.08')) ? _c('router-link', {
    attrs: {
      "to": "/salesinvoice"
    }
  }, [_c('a', [_vm._v("Sales Invoice")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.26')) ? _c('router-link', {
    attrs: {
      "to": "/dairySalesInvoice"
    }
  }, [_c('a', [_vm._v("Dairy Sales Invoice")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.09')) ? _c('router-link', {
    attrs: {
      "to": "/salesreturn"
    }
  }, [_c('a', [_vm._v("Sales Return(Cr. Note)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.18')) ? _c('router-link', {
    attrs: {
      "to": "/salesReturnBillWise"
    }
  }, [_c('a', [_vm._v("Sales Return Billwise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.22')) ? _c('router-link', {
    attrs: {
      "to": "/consumption"
    }
  }, [_c('a', [_vm._v("Consumption")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.23')) ? _c('router-link', {
    attrs: {
      "to": "/damage"
    }
  }, [_c('a', [_vm._v("Damage")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('2.21')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(13), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('2.21')) ? _c('router-link', {
    attrs: {
      "to": "/stockTransferInternal"
    }
  }, [_c('a', [_vm._v("Stock Transfer (Internal)")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('2.11') ||
    this.$store.getters.modules.includes('2.12') ||
    this.$store.getters.modules.includes('2.13') ||
    this.$store.getters.modules.includes('2.25') ||
    this.$store.getters.modules.includes('2.14')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(14), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('2.11')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseorder"
    }
  }, [_c('a', [_vm._v("Purchase Order")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.12')) ? _c('router-link', {
    attrs: {
      "to": "/purchasechallan"
    }
  }, [_c('a', [_vm._v("Purchase Challan")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.13')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseinvoice"
    }
  }, [_c('a', [_vm._v("Purchase Invoice")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.25')) ? _c('router-link', {
    attrs: {
      "to": "/dairyPurchaseInvoice"
    }
  }, [_c('a', [_vm._v("Dairy Purchase Invoice")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.24')) ? _c('router-link', {
    attrs: {
      "to": "/finishedGoods"
    }
  }, [_c('a', [_vm._v("Finished Goods")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.14')) ? _c('router-link', {
    attrs: {
      "to": "/purchasereturn"
    }
  }, [_c('a', [_vm._v("Purchase Return(Dr. Note)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.19')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseReturnBillWise"
    }
  }, [_c('a', [_vm._v("Purchase Return Billwise")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('2.15') || this.$store.getters.modules.includes('2.16') ||
    this.$store.getters.modules.includes('2.17')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(15), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('2.15')) ? _c('router-link', {
    attrs: {
      "to": "/cashwithdraw"
    }
  }, [_c('a', [_vm._v("Cash Withdraw")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.16')) ? _c('router-link', {
    attrs: {
      "to": "/cashdeposit"
    }
  }, [_c('a', [_vm._v("Cash Deposit")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('2.17')) ? _c('router-link', {
    attrs: {
      "to": "banktransfer"
    }
  }, [_c('a', [_vm._v("Bank Transfer")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/postDateCheque"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Post Date Cheque ")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',3.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(16), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(
    this.$store.getters.modules.includes('3.01') ||
    this.$store.getters.modules.includes('3.02') ||
    this.$store.getters.modules.includes('3.03') ||
    this.$store.getters.modules.includes('3.04') ||
    this.$store.getters.modules.includes('3.19')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(17), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.01')) ? _c('router-link', {
    attrs: {
      "to": "/cashBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cash Book")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.02')) ? _c('router-link', {
    attrs: {
      "to": "/dayBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Day Book")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.19')) ? _c('router-link', {
    attrs: {
      "to": "/dayBookWithoutCash"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Day Book w/o cash")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.04')) ? _c('router-link', {
    attrs: {
      "to": "/ledgerInquery"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("General Ledger / Statement")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('3.01') ||
    this.$store.getters.modules.includes('3.02') ||
    this.$store.getters.modules.includes('3.03') ||
    this.$store.getters.modules.includes('3.04') ||
    this.$store.getters.modules.includes('3.19')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(18), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.01')) ? _c('router-link', {
    attrs: {
      "to": "/customerReceivableReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer Receivable")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.02')) ? _c('router-link', {
    attrs: {
      "to": "/supplierPayableReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Supplier Payable")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('3.01') ||
    this.$store.getters.modules.includes('3.02') ||
    this.$store.getters.modules.includes('3.03') ||
    this.$store.getters.modules.includes('3.04') ||
    this.$store.getters.modules.includes('3.19')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(19), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/journalAll"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Transactions Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/journalVoidAll"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Transactions Void Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/journalPendingReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Transactions Pending Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/journalBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Journal Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/paymentBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Payment Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/receiptBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Receipt Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.21')) ? _c('router-link', {
    attrs: {
      "to": "/reversalBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Reversal Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/debitNoteRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Debit Note Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/creditNoteRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Credit Note Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/cashDepositRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cash Deposit Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/cashWithdrawalRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cash Withdrawal Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.03')) ? _c('router-link', {
    attrs: {
      "to": "/bankTransferRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bank Transfer Register")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (
    this.$store.getters.modules.includes('3.22') ||
    this.$store.getters.modules.includes('3.23')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(20), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.22')) ? _c('router-link', {
    attrs: {
      "to": "/costCenterLedger"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cost Center Ledger")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.23')) ? _c('router-link', {
    attrs: {
      "to": "/costCenterSummary"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cost Center Summary")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.11') ||
    this.$store.getters.modules.includes('3.12') ||
    this.$store.getters.modules.includes('3.13')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(21), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.11')) ? _c('router-link', {
    attrs: {
      "to": "/partyStatement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Party Ledger/Statement")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.13')) ? _c('router-link', {
    attrs: {
      "to": "/customerTransactionSummary"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer Transaction Summary")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.12')) ? _c('router-link', {
    attrs: {
      "to": "/supplierTransactionSummary"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Supplier Transaction Summary")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(22), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/bankClosingBalExcludingOverDraft"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bank Closing-Excluding overdraft")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/bankClosingBalIncludingOverDraft"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bank Closing-Including overdraft")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/bankClosingBalOnlyOverDraft"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bank Closing-Only overdraft")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/bankStatement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bank Ledger/Statement")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(23), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/postDateChequeDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Post Date Cheque Details ")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/postDateChequeUnclear"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Uncleared Cheque Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/postDateChequeClear"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cleared Cheque Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/reconciliationStatement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Reconciliation Statement (TO DO)")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(24), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/trailBalanceOpening"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trial Balance - Opening")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/trailBalance"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trial Balance - Closing")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(25), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/profitAndLoss"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" Profit & Loss - Vertical")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(26), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/balanceSheet"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Balance Sheet - Vertical")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('3.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(27), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('3.18')) ? _c('router-link', {
    attrs: {
      "to": "/tradingAccount"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trading Report - Vertical")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',4.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(28), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('4.01') ||
    this.$store.getters.modules.includes('4.02') ||
    this.$store.getters.modules.includes('4.03') ||
    this.$store.getters.modules.includes('4.04') ||
    this.$store.getters.modules.includes('4.13') ||
    this.$store.getters.modules.includes('4.12') ||
    this.$store.getters.modules.includes('4.16') ||
    this.$store.getters.modules.includes('4.15') ||
    this.$store.getters.modules.includes('4.51') ||
    this.$store.getters.modules.includes('4.52') ||
    this.$store.getters.modules.includes('4.53') ||
    this.$store.getters.modules.includes('4.54')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(29), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.01')) ? _c('router-link', {
    attrs: {
      "to": "/salesOrderReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Order Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.16')) ? _c('router-link', {
    attrs: {
      "to": "/salesOrderCompletedReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Order Completed Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.15')) ? _c('router-link', {
    attrs: {
      "to": "/salesOrderPendingReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Delivery Pending Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.02')) ? _c('router-link', {
    attrs: {
      "to": "/salesChallanReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Challan Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.03')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.17')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceVoidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Void Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.04')) ? _c('router-link', {
    attrs: {
      "to": "/salesReturnReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Return Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.51')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceUnpaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Unpaid Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.54')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceChequeReceived"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Cheque Received ")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.53')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoicePaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Paid Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.48')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceTodayUnpaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Payment Todays Follow (TO-DO)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.48')) ? _c('router-link', {
    attrs: {
      "to": "/salesPaymentFollowUpTodaysReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Payment Todays FollowUp (DONE) ")])]) : _vm._e()], 1), _vm._v(" "), _c('li'), _c('li', [(this.$store.getters.modules.includes('4.48')) ? _c('router-link', {
    attrs: {
      "to": "/salesUnpaidNextFollowUpReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Payment Next FollowUp Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.47')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceUnpaidAndPaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Unpaid And Paid Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.52')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceUnreceivedReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Unreceived Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.45')) ? _c('router-link', {
    attrs: {
      "to": "/salesInvoiceUnreceivedAllReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Invoice Unreceived All Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.18')) ? _c('router-link', {
    attrs: {
      "to": "/consumptionReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Consumption Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.19')) ? _c('router-link', {
    attrs: {
      "to": "/damageReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Damage Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.12')) ? _c('router-link', {
    attrs: {
      "to": "/salesTaxRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Tax Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.12')) ? _c('router-link', {
    attrs: {
      "to": "/salesSummaryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Summary Report")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.05') ||
    this.$store.getters.modules.includes('4.06') ||
    this.$store.getters.modules.includes('4.07') ||
    this.$store.getters.modules.includes('4.08') || this.$store.getters.modules.includes('4.13')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(30), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.05')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseOrderReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Order Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.06')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseChallanReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Challan Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.07')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseInvoiceReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Invoice Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.21')) ? _c('router-link', {
    attrs: {
      "to": "/finishedGoods"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Finished Goods Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.08')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseReturnReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Return Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.13')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseTaxRegister"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Tax Register")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.13')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseSummaryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("purchase Summary Report")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.14') || this.$store.getters.modules.includes('4.39')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(31), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.14')) ? _c('router-link', {
    attrs: {
      "to": "/stockTransforReportInternal"
    }
  }, [_c('a', [_vm._v("Transfer Report (Internal)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.14')) ? _c('router-link', {
    attrs: {
      "to": "/stockTransforReportWarehouseWise"
    }
  }, [_c('a', [_vm._v("Transfer Report Store Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.39')) ? _c('router-link', {
    attrs: {
      "to": "/stockTransforReportInternalUser"
    }
  }, [_c('a', [_vm._v("Transfer Report (Internal) User")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.08') ||
    this.$store.getters.modules.includes('4.11') ||
    this.$store.getters.modules.includes('4.09') ||
    this.$store.getters.modules.includes('4.22') ||
    this.$store.getters.modules.includes('4.23') ||
    this.$store.getters.modules.includes('4.24') ||
    this.$store.getters.modules.includes('4.25') ||
    this.$store.getters.modules.includes('4.26') ||
    this.$store.getters.modules.includes('4.41')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(32), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.09')) ? _c('router-link', {
    attrs: {
      "to": "/itemDayBook"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Day Book")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.11')) ? _c('router-link', {
    attrs: {
      "to": "/itemStatement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("General Item Ledger/Statement")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.42')) ? _c('router-link', {
    attrs: {
      "to": "/itemPurchaseDetailReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Purchase History Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.43')) ? _c('router-link', {
    attrs: {
      "to": "/itemSalesDetailReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Sales History Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.09')) ? _c('router-link', {
    attrs: {
      "to": "/inventoryInOutReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inventory In/Out Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.11')) ? _c('router-link', {
    attrs: {
      "to": "/itemInOutStoreWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inventory In/Out - Store Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.11')) ? _c('router-link', {
    attrs: {
      "to": "/closingStock"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Closing Stock")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.11')) ? _c('router-link', {
    attrs: {
      "to": "/negativeStockReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Negative Stock Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.24')) ? _c('router-link', {
    attrs: {
      "to": "/storeWiseClosingStock"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Closing Stock (Counter Wise)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.41')) ? _c('router-link', {
    attrs: {
      "to": "/storeWiseClosingStockUser"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Closing Stock (Counter Wise) User")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.23')) ? _c('router-link', {
    attrs: {
      "to": "/storeAndItemWiseClosingStock"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Closing Stock (Store Wise)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.22')) ? _c('router-link', {
    attrs: {
      "to": "/itemMasterListForRates"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Update Sales & Purchase Rate")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.25') ||
    this.$store.getters.modules.includes('4.26')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(33), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.25')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Product Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.26')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisSupplierWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Supplier Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.29')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisMonthlyProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Product Monthly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.31')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisMonthlySupplierWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Supplier Monthly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.34')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisQuarterlyProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Product Quarterly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.35')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseAnalysisQuarterlySupplierWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Supplier Quarterly Wise")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.27') ||
    this.$store.getters.modules.includes('4.28')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(34), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.27')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Product Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.28')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisCustomerWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Customer Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.32')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisMonthlyProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Product Monthly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.33')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisMonthlyCustomerWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Customer Monthly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.33')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisMonthlyCustomerFiscalYearWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Fiscal Year Customer Monthly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.36')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisQuarterlyProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Product Quarterly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.37')) ? _c('router-link', {
    attrs: {
      "to": "/salesAnalysisQuarterlyCustomerWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Customer Quarterly Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.46')) ? _c('router-link', {
    attrs: {
      "to": "/customerWiseSalesCount"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer Wise Sales Count")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('4.38')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(35), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('4.38')) ? _c('router-link', {
    attrs: {
      "to": "/profitAndLossAnalysisProductWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profit And Loss Analysis Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.38')) ? _c('router-link', {
    attrs: {
      "to": "/profitAndLossAnalysis"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profit/Loss Analysis Item Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.44')) ? _c('router-link', {
    attrs: {
      "to": "/profitReportGross"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profit Report Gross")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.49')) ? _c('router-link', {
    attrs: {
      "to": "/expensesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Expenses Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.55')) ? _c('router-link', {
    attrs: {
      "to": "/salesPaidCollectionReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Paid Collection Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('4.56')) ? _c('router-link', {
    attrs: {
      "to": "/monthlyDueAnalysisReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly Due Analysis Report")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',15.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(36), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('15.01')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(37), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('15.01')) ? _c('router-link', {
    attrs: {
      "to": "/purchaseSalesGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Purchase Sales")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.02')) ? _c('router-link', {
    attrs: {
      "to": "/receiptPaymentGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Receipt Payment")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.03')) ? _c('router-link', {
    attrs: {
      "to": "/salesTragetGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly Sales Target")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.04')) ? _c('router-link', {
    attrs: {
      "to": "/itemSalesMonthlyGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Wise Monthly Graph Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.05')) ? _c('router-link', {
    attrs: {
      "to": "/WeeklySalesReportGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Weekly Sales Report Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.06')) ? _c('router-link', {
    attrs: {
      "to": "/ItemWiseProfitLossAnalysisGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Wise Profit Loss Analysis Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.07')) ? _c('router-link', {
    attrs: {
      "to": "/DailySalesReportGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Daily Sales Report Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.08')) ? _c('router-link', {
    attrs: {
      "to": "/CustomerWiseSalesCountGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer Wise Sales Count Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.09')) ? _c('router-link', {
    attrs: {
      "to": "/UserWiseSalesGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("User Wise Sales Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.11')) ? _c('router-link', {
    attrs: {
      "to": "/GrossMarginGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Gross Margin Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.12')) ? _c('router-link', {
    attrs: {
      "to": "/salesPaidCashCollectionGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly Sales Payment Collection Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('15.13')) ? _c('router-link', {
    attrs: {
      "to": "/DueAnalysisGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly Due Analysis Graph")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',6.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(38), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('6.01')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryEntryForm"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Delivery Entry From")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.15')) ? _c('router-link', {
    attrs: {
      "to": "/toBeVerifyDelivery"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("To Be Verify Delivery")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.02')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Delivery Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.03')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryUserTrack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Delivery User Track")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.04')) ? _c('router-link', {
    attrs: {
      "to": "/deliveredReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Completed Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.05')) ? _c('router-link', {
    attrs: {
      "to": "/vendorDeliveryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Vendor Delivery Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.06')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryRequestReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Request Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.09')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryPendingReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pending Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.13')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryCancelledReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.07')) ? _c('router-link', {
    attrs: {
      "to": "/vendorPaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Vendor Paid Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.08')) ? _c('router-link', {
    attrs: {
      "to": "/vendorUnPaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Vendor Unpaid Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.14')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryReturnedReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Return To Vendor Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('6.12')) ? _c('router-link', {
    attrs: {
      "to": "/deliveryRemarksLogReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Remarks Log Report")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',13.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(39), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('13.04')) ? _c('router-link', {
    attrs: {
      "to": "/ecommercePending"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pending Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('13.01')) ? _c('router-link', {
    attrs: {
      "to": "/ecommerceOrder"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Processing Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('13.02')) ? _c('router-link', {
    attrs: {
      "to": "/ecommerceCancelled"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancelled Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('13.03')) ? _c('router-link', {
    attrs: {
      "to": "/ecommerceCompleted"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Completed Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('13.05')) ? _c('router-link', {
    attrs: {
      "to": "/ecommerceHold"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Hold Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('13.06')) ? _c('router-link', {
    attrs: {
      "to": "/ecommerceInquiry"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inquiry")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',9.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(40), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('9.15') ||
    this.$store.getters.modules.includes('9.16') || this.$store.getters.modules.includes('9.17') ||
    this.$store.getters.modules.includes('9.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(41), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('9.01')) ? _c('router-link', {
    attrs: {
      "to": "/categorySetup"
    }
  }, [_c('a', [_vm._v("Item Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.02')) ? _c('router-link', {
    attrs: {
      "to": "/subCategorySetup"
    }
  }, [_c('a', [_vm._v("Item Sub Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.03')) ? _c('router-link', {
    attrs: {
      "to": "/faItemMaster"
    }
  }, [_c('a', [_vm._v("Item Master")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.04')) ? _c('router-link', {
    attrs: {
      "to": "/poolConfiguration"
    }
  }, [_c('a', [_vm._v("Pool Setup ")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.05')) ? _c('router-link', {
    attrs: {
      "to": "/faExtraExpenses"
    }
  }, [_c('a', [_vm._v("Bill Sundary ")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.06')) ? _c('router-link', {
    attrs: {
      "to": "/faExtraExpensesItemwise"
    }
  }, [_c('a', [_vm._v("Bill Sundary Item Wise ")])]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('9.15') ||
    this.$store.getters.modules.includes('9.16') || this.$store.getters.modules.includes('9.17') ||
    this.$store.getters.modules.includes('9.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(42), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('9.15')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsPurchaseOrder"
    }
  }, [_c('a', [_vm._v("Purchase Order")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.16')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsPurchaseChallan"
    }
  }, [_c('a', [_vm._v("Purchase Challan")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.17')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsPurchaseInvoice"
    }
  }, [_c('a', [_vm._v("Purchase Invoice")])]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('9.11') ||
    this.$store.getters.modules.includes('9.12') || this.$store.getters.modules.includes('9.13') ||
    this.$store.getters.modules.includes('9.14')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(43), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('9.11')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsSalesOrder"
    }
  }, [_c('a', [_vm._v("Sales Order")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.12')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsSalesChallan"
    }
  }, [_c('a', [_vm._v("Sales Challan")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.13')) ? _c('router-link', {
    attrs: {
      "to": "/fixedAssetsSalesInvoice"
    }
  }, [_c('a', [_vm._v("Sales Invoice")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',7.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(44), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('7.01') ||
    this.$store.getters.modules.includes('7.02') || this.$store.getters.modules.includes('7.03') ||
    this.$store.getters.modules.includes('7.04') ||
    this.$store.getters.modules.includes('7.05') ||
    this.$store.getters.modules.includes('7.06') ||
    this.$store.getters.modules.includes('7.07') ||
    this.$store.getters.modules.includes('7.08')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(45), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('7.01')) ? _c('router-link', {
    attrs: {
      "to": "/posEntry"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Entry")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.02')) ? _c('router-link', {
    attrs: {
      "to": "/posSalesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Settle Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.03')) ? _c('router-link', {
    attrs: {
      "to": "/unSettlePosSalesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unsettle Sales")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.13')) ? _c('router-link', {
    attrs: {
      "to": "/posUnpaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unpaid Sales")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.14')) ? _c('router-link', {
    attrs: {
      "to": "/posAllUnPaidReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("All Unpaid Sales")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.15')) ? _c('router-link', {
    attrs: {
      "to": "/posDublicateSalesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Dublicate Sales Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.15')) ? _c('router-link', {
    attrs: {
      "to": "/posSalesDeleteReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sales Deleted Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.05')) ? _c('router-link', {
    attrs: {
      "to": "/posDailySalesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Daily Sales Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.02')) ? _c('router-link', {
    attrs: {
      "to": "/posCustomerSalesReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pos Customer Sales Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('7.06')) ? _c('router-link', {
    attrs: {
      "to": "/posSalesReturnBillwise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pos Sales Return Billwise")])]) : _vm._e()], 1), _vm._v(" "), (this.$store.getters.modules.includes('7.07')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/posItemWiseStockMgmt"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Stock Adjustment")])])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('7.08')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/posClosingStock"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Closing Stock")])])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('7.09')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/stockInHistoryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Stock In History Report")])])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('7.04')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/counterSetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Counter Setup")])])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('7.17')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/rewardPoint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Reward Point")])])], 1) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',9.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(46), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('9.01') ||
    this.$store.getters.modules.includes('9.02') || this.$store.getters.modules.includes('9.03') ||
    this.$store.getters.modules.includes('9.04') ||
    this.$store.getters.modules.includes('9.05') ||
    this.$store.getters.modules.includes('9.06') ||
    this.$store.getters.modules.includes('9.07')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(47), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('9.01')) ? _c('router-link', {
    attrs: {
      "to": "/categorySetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.02')) ? _c('router-link', {
    attrs: {
      "to": "/subCategorySetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sub-Category")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.03')) ? _c('router-link', {
    attrs: {
      "to": "/faItemMaster"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("FA Item Master")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.04')) ? _c('router-link', {
    attrs: {
      "to": "/faExtraExpenses"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("FA Extra Expenses")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.05')) ? _c('router-link', {
    attrs: {
      "to": "/faExtraExpensesItemwise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("FA Extra Expenses Item Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('9.06')) ? _c('router-link', {
    attrs: {
      "to": "/poolConfiguration"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pool Configuration")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',8.')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(48), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.33')) ? _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")])]) : _vm._e()], 1), _vm._v(" "), (this.$store.getters.modules.includes('8.01') ||
    this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03') ||
    this.$store.getters.modules.includes('8.04') ||
    this.$store.getters.modules.includes('8.05') ||
    this.$store.getters.modules.includes('8.06')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(49), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.01')) ? _c('router-link', {
    attrs: {
      "to": "/jobTitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Job Title")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.02')) ? _c('router-link', {
    attrs: {
      "to": "/employmentStatus"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Employment Status")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.03')) ? _c('router-link', {
    attrs: {
      "to": "/jobCategory"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Job Category")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.04')) ? _c('router-link', {
    attrs: {
      "to": "/workShift"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Work Shift")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.05')) ? _c('router-link', {
    attrs: {
      "to": "/shiftManagement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shift Management")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.06')) ? _c('router-link', {
    attrs: {
      "to": "/terminationReason"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Termination Reason")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.07') ||
    this.$store.getters.modules.includes('8.08') || this.$store.getters.modules.includes('8.09') ||
    this.$store.getters.modules.includes('8.11') ||
    this.$store.getters.modules.includes('8.12') ||
    this.$store.getters.modules.includes('8.13')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(50), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.07')) ? _c('router-link', {
    attrs: {
      "to": "/skills"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Skills")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.08')) ? _c('router-link', {
    attrs: {
      "to": "/education"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Education")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.09')) ? _c('router-link', {
    attrs: {
      "to": "/language"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Language")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.11')) ? _c('router-link', {
    attrs: {
      "to": "/license"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("License")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.12')) ? _c('router-link', {
    attrs: {
      "to": "/membership"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Membership")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.13')) ? _c('router-link', {
    attrs: {
      "to": "/nationality"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Nationality")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.14') ||
    this.$store.getters.modules.includes('8.15') || this.$store.getters.modules.includes('8.16') ||
    this.$store.getters.modules.includes('8.17') ||
    this.$store.getters.modules.includes('8.18')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(51), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.14')) ? _c('router-link', {
    attrs: {
      "to": "/leaveType"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Leave type")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.15')) ? _c('router-link', {
    attrs: {
      "to": "/leavePeriod"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Leave Period")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.16')) ? _c('router-link', {
    attrs: {
      "to": "/workingWeek"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Working week")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.17')) ? _c('router-link', {
    attrs: {
      "to": "/holidays"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Holidays")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.18')) ? _c('router-link', {
    attrs: {
      "to": "/leaveEntitlement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Entitlement")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.19') ||
    this.$store.getters.modules.includes('8.21')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(52), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.19')) ? _c('router-link', {
    attrs: {
      "to": "/payHead"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pay Head")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.21')) ? _c('router-link', {
    attrs: {
      "to": "/payGrade"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Pay Grade")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.22')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(53), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.22')) ? _c('router-link', {
    attrs: {
      "to": "/employeeGroup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Employee Group")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.22')) ? _c('router-link', {
    attrs: {
      "to": "/employeePosition"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Employee SubGroup")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.22')) ? _c('router-link', {
    attrs: {
      "to": "/employeeSubGroup1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Employee SubGroup Child")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.22')) ? _c('router-link', {
    attrs: {
      "to": "/addEmployee"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Manage Employee")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.23')) ? _c('router-link', {
    attrs: {
      "to": "employeeTransfer"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Employee Transfer")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.24') ||
    this.$store.getters.modules.includes('8.25')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(54), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.24')) ? _c('router-link', {
    attrs: {
      "to": "/leaveRequest"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Request")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.25')) ? _c('router-link', {
    attrs: {
      "to": "/leaveReports"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Reports")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.26') ||
    this.$store.getters.modules.includes('8.27')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(55), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.26')) ? _c('router-link', {
    attrs: {
      "to": "/attendanceRequest"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Attendance Request")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.26')) ? _c('router-link', {
    attrs: {
      "to": "/attendanceRequestReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Attendance Request Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.27')) ? _c('router-link', {
    attrs: {
      "to": "/leaveReports"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Late and Early Request")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.28') ||
    this.$store.getters.modules.includes('8.29')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(56), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.28')) ? _c('router-link', {
    attrs: {
      "to": "/salaryEntry"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Salary Entry")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.29')) ? _c('router-link', {
    attrs: {
      "to": "/salaryReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Salary Report")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('8.31') ||
    this.$store.getters.modules.includes('8.32')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(57), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('8.31')) ? _c('router-link', {
    attrs: {
      "to": "/inventoryAssignEntry"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inventory Assign Entry")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('8.32')) ? _c('router-link', {
    attrs: {
      "to": "/inventoryAssignReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Inventory Assign Report")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',12.')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(58), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('12.01') ||
    this.$store.getters.modules.includes('12.02') || this.$store.getters.modules.includes('12.03') ||
    this.$store.getters.modules.includes('12.04') || this.$store.getters.modules.includes('12.11')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(59), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('12.01')) ? _c('router-link', {
    attrs: {
      "to": "/crmClientDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Client Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.02')) ? _c('router-link', {
    attrs: {
      "to": "/crmCompanies"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Companies")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.03')) ? _c('router-link', {
    attrs: {
      "to": "/crmCustomer"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.04')) ? _c('router-link', {
    attrs: {
      "to": "/crmProductDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Product Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.12')) ? _c('router-link', {
    attrs: {
      "to": "/crmMasterSetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Master Setup")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('12.06') ||
    this.$store.getters.modules.includes('12.07') || this.$store.getters.modules.includes('12.08') ||
    this.$store.getters.modules.includes('12.04') || this.$store.getters.modules.includes('12.11') || this.$store.getters.modules.includes('12.24')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(60), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('12.08')) ? _c('router-link', {
    attrs: {
      "to": "/crmVIsitorDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Visitors")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.04')) ? _c('router-link', {
    attrs: {
      "to": "/crmDealDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Deal Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.06')) ? _c('router-link', {
    attrs: {
      "to": "/crmTaskDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Task")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.07')) ? _c('router-link', {
    attrs: {
      "to": "/crmTicketDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Ticket Details")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.11')) ? _c('router-link', {
    attrs: {
      "to": "/crmFollowUpDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Up")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.24')) ? _c('router-link', {
    attrs: {
      "to": "/crmAllFollowUpDetails"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Up All List")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('12.11') ||
    this.$store.getters.modules.includes('12.12') || this.$store.getters.modules.includes('12.13') ||
    this.$store.getters.modules.includes('12.14')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(61), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('12.13')) ? _c('router-link', {
    attrs: {
      "to": "/crmCustomerWiseReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Customer Wise Next Follow Up")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.14')) ? _c('router-link', {
    attrs: {
      "to": "/crmTodayFollowUp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Todays FollowUp (To Do)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.15')) ? _c('router-link', {
    attrs: {
      "to": "/crmTotalTodayFollowUp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Total Todays FollowUp (Done)")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.16')) ? _c('router-link', {
    attrs: {
      "to": "/crmNotReceivedCalls"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Call Not Received")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.19')) ? _c('router-link', {
    attrs: {
      "to": "/crmFollowUpDateRange"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Up Between Date")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.17')) ? _c('router-link', {
    attrs: {
      "to": "/quotationSent"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quotation Sent")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.18')) ? _c('router-link', {
    attrs: {
      "to": "/sampleSent"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sample Sent")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('12.21') ||
    this.$store.getters.modules.includes('12.22') || this.$store.getters.modules.includes('12.23')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(62), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('12.21')) ? _c('router-link', {
    attrs: {
      "to": "/crmStageWiseGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM Stage Wise Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.22')) ? _c('router-link', {
    attrs: {
      "to": "/crmUserWiseGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM User Wise Graph")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('12.23')) ? _c('router-link', {
    attrs: {
      "to": "/crmUserWiseMonthlyGraph"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM User Wise Monthly Graph")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes(',5.')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(63), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [(this.$store.getters.modules.includes('5.01') ||
    this.$store.getters.modules.includes('5.02') || this.$store.getters.modules.includes('5.05')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(64), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('5.01')) ? _c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("User")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.02')) ? _c('router-link', {
    attrs: {
      "to": "/role"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Role")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.37')) ? _c('router-link', {
    attrs: {
      "to": "/branchCompany"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Branch Company")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.14')) ? _c('router-link', {
    attrs: {
      "to": "/basicAccountSetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Basic Account Setup")])]) : _vm._e()], 1), _vm._v(" "), (this.$store.getters.modules.includes('5.03')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(65), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('5.03')) ? _c('router-link', {
    attrs: {
      "to": "/fiscalYear"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fiscal Year")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.18')) ? _c('router-link', {
    attrs: {
      "to": "/fiscalYearSettlement"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fiscal Year Settlement")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.19')) ? _c('router-link', {
    attrs: {
      "to": "/balanceBroughtDown"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fiscal Year Broughtdown")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.19')) ? _c('router-link', {
    attrs: {
      "to": "/itemBroughtDownStoreWise"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Item Balance Broughtdown Store Wise")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.21')) ? _c('router-link', {
    attrs: {
      "to": "/fiscalYearSettledReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fiscal Year Settled Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.22')) ? _c('router-link', {
    attrs: {
      "to": "/balanceCarryOverReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fiscal Year Broughtdown Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.24')) ? _c('router-link', {
    attrs: {
      "to": "/autoSettelTransaction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Auto Settle Inventory And Account")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.03')) ? _c('router-link', {
    attrs: {
      "to": "/monthlyTarget"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Monthly Sales Target")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.36')) ? _c('router-link', {
    attrs: {
      "to": "/irdsetup"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("IRD Setup")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('5.03')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(66), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('5.03')) ? _c('router-link', {
    attrs: {
      "to": "/excelUpload"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Excel Upload")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('5.25') || this.$store.getters.modules.includes('5.26')) ? _c('li', {
    staticClass: "treeview menu-open"
  }, [_vm._m(67), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [(this.$store.getters.modules.includes('5.25')) ? _c('router-link', {
    attrs: {
      "to": "/sendSms"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Send SMS")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.26')) ? _c('router-link', {
    attrs: {
      "to": "/smsReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("SMS QUEUE Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.27')) ? _c('router-link', {
    attrs: {
      "to": "/smsFailedReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("SMS Failed Report")])]) : _vm._e()], 1), _vm._v(" "), _c('li', [(this.$store.getters.modules.includes('5.28')) ? _c('router-link', {
    attrs: {
      "to": "/smsSentReport"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("SMS Sent Report")])]) : _vm._e()], 1)])]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Event Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Event Management\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Master")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Master\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Master")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Account\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Inventory\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Store\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Bill Sundry\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Cost Center\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Transaction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Account\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Sales\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Stock Transfer\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Purchase\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Banking\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Accounting Report")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Account Book\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Outstanding Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Account Register\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Cost Center\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Party Book\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Banking Book\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Bank Reconciliation\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Trial Balance\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Profit & Loss\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Balance Sheet\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Trading Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Inventory Report")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Sales Register\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Purchase Register\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Stock Transfer Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Stock Book\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Purchase Analysis Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Sales Analysis Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Profit And Loss Analysis Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Graph View")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Graphs\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Delivery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Ecommerce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Fixed Assets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Master\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Purchase\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Sales\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cart-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("POS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            POS\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cart-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Fixed Assets")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Fixed Assets Master\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Human Resource")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Job\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Qualification\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Leave\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Pay\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Employee\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Leave and Fieldwork\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Attendance\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Pay Roll\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Inventory Assign\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Crm")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Master\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Entry\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Report\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Graph\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "treeview-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Setting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            User/Role\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Transaction\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            Master Setup\n            "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n            SMS\n            "), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722108c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 2309
// module chunks = 0